<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#4CAF50" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              :key="currentImage"
              @stepper="imageCropper"
              :cropheight="225"
              :cropwidth="205"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <div class="add-product-page">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <!-- <v-icon class="page-title-icon">mdi-package-variant-plus</v-icon> -->
          <div>
            <h1 class="page-title">Add New Product</h1>
            <!-- <p class="page-subtitle">Fill in the details below to list your product</p> -->
          </div>
        </div>
      </div>

      <!-- Form Body -->
      <div class="form-body">
        <v-row>
          <!-- LEFT COLUMN -->
          <v-col cols="12" lg="8" class="form-left-col">

            <!-- 01 Basic Information -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">01</span>
                <div>
                  <h2 class="section-title">Basic Information</h2>
                  <!-- <p class="section-desc">Product name, description and specifications</p> -->
                </div>
              </div>
              <div class="section-body">
                <div class="field-group">
                  <label class="field-label">Product Name <span class="required">*</span></label>
                  <v-text-field
                    v-model="product.productname"
                    color="#4CAF50"
                    outlined dense hide-details
                    placeholder="Enter product name"
                    class="modern-input"
                  ></v-text-field>
                  <span v-if="NameMsg" class="field-error">{{ NameMsg }}</span>
                </div>

                <div class="field-group">
                  <label class="field-label">Description <span class="required">*</span></label>
                  <v-textarea
                    rows="3"
                    v-model="product.description"
                    color="#4CAF50"
                    outlined dense hide-details counter
                    placeholder="Describe your product in detail"
                    class="modern-input"
                  ></v-textarea>
                </div>

                <div class="field-group">
                  <label class="field-label">Specifications</label>
                  <div class="editor-wrapper">
                    <vue-editor v-model="product.specifications"></vue-editor>
                  </div>
                </div>

                <div class="field-group">
                  <label class="field-label">YouTube Link</label>
                  <v-text-field
                    v-model="product.link"
                    color="#4CAF50"
                    outlined dense hide-details
                    placeholder="https://youtube.com/watch?v=..."
                    prepend-inner-icon="mdi-youtube"
                    class="modern-input"
                  ></v-text-field>
                </div>
              </div>
            </div>

            <!-- 02 Pricing & Offers -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">02</span>
                <div>
                  <h2 class="section-title">Pricing &amp; Offers</h2>
                  <!-- <p class="section-desc">Set price, discounts and calculated offer price</p> -->
                </div>
              </div>
              <div class="section-body">
                <v-row>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Price (&#8377;) <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.price"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0.00"
                        prepend-inner-icon="mdi-currency-inr"
                        class="modern-input"
                        @input="checkDiscountvariant()"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Offer Percentage (%)</label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.offer"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0"
                        prepend-inner-icon="mdi-tag-percentage"
                        class="modern-input"
                        @input="checkDiscountvariant()"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Offer Price (&#8377;)</label>
                      <v-text-field
                        disabled
                        type="number" min="0"
                        v-model="product.offerPrice"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="Auto-calculated"
                        prepend-inner-icon="mdi-sale"
                        class="modern-input offer-price-field"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- 03 Stock & Quantity -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">03</span>
                <div>
                  <h2 class="section-title">Stock &amp; Quantity</h2>
                  <!-- <p class="section-desc">Manage inventory and order limits</p> -->
                </div>
              </div>
              <div class="section-body">
                <v-row>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Available Quantity <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.quantity"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0"
                        prepend-inner-icon="mdi-warehouse"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Unit</label>
                      <v-select
                        v-model="product.unit"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="Select unit"
                        :items="unitsItems"
                        item-text="name"
                        item-value="value"
                        prepend-inner-icon="mdi-scale"
                        class="modern-input"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Minimum Order Quantity <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.minimumOrderQuantity"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="1"
                        prepend-inner-icon="mdi-arrow-collapse-down"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Maximum Order Quantity <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.maxOrderQuantity"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="100"
                        prepend-inner-icon="mdi-arrow-collapse-up"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- 04 Delivery & Charges -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">04</span>
                <div>
                  <h2 class="section-title">Delivery &amp; Charges</h2>
                  <!-- <p class="section-desc">Mode of delivery, packing and shipping costs</p> -->
                </div>
              </div>
              <div class="section-body">
                <v-row>
                  <v-col cols="12">
                    <div class="field-group">
                      <label class="field-label">Mode of Delivery <span class="required">*</span></label>
                      <v-select
                        v-model="product.modeOfDelivery"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="Select delivery mode"
                        :items="modeOfDeliveryItems"
                        prepend-inner-icon="mdi-truck-outline"
                        class="modern-input"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Packing Charge (&#8377;) <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.packingCharge"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0.00"
                        prepend-inner-icon="mdi-package"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Delivery Inside Kerala (&#8377;) <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.deliveryChargeInsideKerala"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0.00"
                        prepend-inner-icon="mdi-map-marker"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="field-group">
                      <label class="field-label">Delivery Outside Kerala (&#8377;) <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.deliveryChargeOutsideKerala"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0.00"
                        prepend-inner-icon="mdi-map-marker-distance"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Tax (%) <span class="required">*</span></label>
                      <v-text-field
                        type="number" min="0"
                        @keydown="preventSymbols"
                        v-model="product.tax"
                        color="#4CAF50"
                        outlined dense hide-details
                        placeholder="0"
                        prepend-inner-icon="mdi-percent"
                        class="modern-input"
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- 05 Categories -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">05</span>
                <div>
                  <h2 class="section-title">Categories</h2>
                  <!-- <p class="section-desc">Classify your product for easier discovery</p> -->
                </div>
              </div>
              <div class="section-body">
                <v-row>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Main Category <span class="required">*</span></label>
                      <v-select
                        outlined dense
                        v-model="product.mainCategory"
                        color="#4CAF50"
                        placeholder="Select main category"
                        :items="maincategoryArray"
                        item-text="name"
                        item-value="_id"
                        item-color="#4CAF50"
                        hide-details
                        prepend-inner-icon="mdi-shape"
                        class="modern-input"
                        @input="getCategory()"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div class="field-group">
                      <label class="field-label">Category <span class="required">*</span></label>
                      <v-select
                        outlined small-chips deletable-chips dense multiple
                        v-model="product.category"
                        color="#4CAF50"
                        placeholder="Select categories"
                        :items="categoryArray"
                        item-text="name"
                        item-value="_id"
                        item-color="#4CAF50"
                        hide-details
                        prepend-inner-icon="mdi-tag-multiple"
                        class="modern-input"
                        @input="getSubcategory()"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div class="field-group">
                      <label class="field-label">Subcategory <span class="required">*</span></label>
                      <v-select
                        outlined small-chips deletable-chips dense multiple
                        v-model="product.subcategory"
                        color="#4CAF50"
                        placeholder="Select subcategories"
                        :items="subcategoryArray"
                        item-text="name"
                        item-value="_id"
                        item-color="#4CAF50"
                        hide-details
                        prepend-inner-icon="mdi-tag"
                        class="modern-input"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- 06 Variants -->
            <div class="form-section">
              <div class="section-header">
                <span class="section-number">06</span>
                <div>
                  <h2 class="section-title">Variants</h2>
                </div>
              </div>
              <div class="section-body">
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="product.isVariantAvailable"
                      label="Is variant available for this product?"
                      color="#4CAF50"
                      hide-details
                      class="mb-4"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <div v-if="product.isVariantAvailable">
                  <v-row>
                    <v-col cols="12">
                      <div class="field-group">
                        <label class="field-label">Current Product Variant Name <span class="required">*</span></label>
                        <v-text-field
                          v-model="product.variantName"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="E.g., Red, Large, 128GB"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <div class="field-group mt-4">
                    <label class="field-label">Related Variants</label>
                    <v-row v-for="(variant, index) in product.variants" :key="index" class="mb-2 align-center">
                      <v-col cols="12" sm="5">
                        <v-select
                          v-model="variant.productId"
                          :items="sellerProducts"
                          item-text="productname"
                          item-value="_id"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Select Product"
                          class="modern-input"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          v-model="variant.variantName"
                          color="#4CAF50"
                          outlined dense hide-details
                          placeholder="Variant Name"
                          class="modern-input"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-btn icon color="#FF3434" @click="product.variants.splice(index, 1)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-btn small outlined color="#4CAF50" class="mt-2 text-capitalize" @click="product.variants.push({productId: '', variantName: ''})">
                      <v-icon left small>mdi-plus</v-icon> Add Variant Link
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit (mobile / tablet only) -->
            <div class="submit-area-mobile hidden-lg-and-up">
              <v-btn block large dark color="#4CAF50" depressed
                class="submit-btn text-capitalize" :ripple="false"
                @click="validateInput()">
                <v-icon left>mdi-check-circle</v-icon>
                Add Product
              </v-btn>
            </div>

          </v-col>

          <!-- RIGHT COLUMN: Image Panel -->
          <v-col cols="12" lg="4" class="form-right-col">
            <div class="image-section sticky-panel">

              <!-- Header -->
              <div class="image-section-header">
                <v-icon color="#4CAF50" class="mr-2">mdi-image-multiple</v-icon>
                <span class="image-section-title">Product Images</span>
                <span class="image-count-badge">{{ imageArray.length }}/4</span>
              </div>

              <!-- Main Image -->
              <div class="main-image-container">
                <div class="main-image-wrapper">
                  <v-img
                    v-if="imageArray[0]"
                    :src="imageArray[0]"
                    height="260px"
                    contain
                    class="main-image"
                  >
                    <v-btn
                      absolute top right icon x-small color="#FF3434"
                      class="remove-img-btn"
                      @click="removeImageArray(0)"
                    >
                      <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-img>
                  <v-img
                    v-else
                    src="../../../assets/Images/No-Image-Placeholder.svg.png"
                    height="260px"
                    contain
                    class="main-image"
                  >
              
                  </v-img>
                </div>
              </div>

              <!-- Thumbnails (only shown when >1 image) -->
              <div class="thumbnail-strip" v-if="imageArray.length > 1">
                <div
                  v-for="(item, i) in imageArray"
                  :key="i"
                  v-show="i > 0"
                  class="thumbnail-wrapper"
                >
                  <v-img :src="item" height="72px" width="72px" cover class="thumbnail-img">
                    <v-btn
                      absolute top right icon x-small color="#FF3434"
                      class="remove-thumb-btn"
                      @click="removeImageArray(i)"
                    >
                      <v-icon color="white" x-small>mdi-close</v-icon>
                    </v-btn>
                  </v-img>
                </div>
              </div>

              <!-- Upload Area -->
              <div class="upload-area" @click="$refs.files.click()">
                <v-icon color="#4CAF50" class="upload-icon">mdi-cloud-upload-outline</v-icon>
                <span class="upload-label">Click to upload images</span>
                <span class="upload-hint">JPEG, PNG, WEBP &middot; max 4 images</span>
              </div>
              <input
                v-show="false"
                accept="image/*"
                id="file"
                ref="files"
                multiple="multiple"
                type="file"
                @change="uploadImages"
              />

              <!-- Submit (desktop) -->
              <div class="hidden-md-and-down">
                <v-btn block large dark color="#4CAF50" depressed
                  class="submit-btn text-capitalize" :ripple="false"
                  @click="validateInput()">
                  <v-icon left>mdi-check-circle</v-icon>
                  Add Product
                </v-btn>
              </div>

            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
// import StockAdder from "./stockAdder";
// import PriceDistro from "./priceDistro";
import ImageCropper from "./../../Common/imageCropper";
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    // StockAdder,
    // PriceDistro,
    ImageCropper,
    VueEditor,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      imageArray: [],
      Images: new FormData(),
      formData: new FormData(),
      selectedFiles: null,
      image: null,
      pid: "",
      pincodeArray: [],
      tagArray: [],
      materialArray: [],
      brandArray: [],
      subSizeArray: [],
      productStock: {},
      radios: null,
      product: {
        isVariantAvailable: false,
        variantName: "",
        variants: []
      },
      sellerProducts: [],
      categoryArray: [],
      subcategoryArray: [],
      productTags: [],
      priceStatus: false,
      price: {
        productCost: null,
        // profitMargin: null,
        deliveryCharge: null,
        gst: null,
        finalCustomerCharge: null,
        styloopCommision: null,
        styloopGST: null,
        tcs: null,
        paymentGateewayCharge: null,
        amountToSeller: null,
        gstPercentage: null,
        styloopCommisionPercentage: null,
        styloopGstPercentage: null,
        tcsPercentage: null,
        paymentGatewayChargePercentage: null,
      },

      rules: {
        required: (value) => !!value || "Required.",
      },
      unitsItems: ["Count", "Kg", "gm", "litre"],
      modeOfDeliveryItems: [],
      cropImageDialog: false,
      currentImage: null,
      singleSubcatData: {},
      NameMsg: null,
      newprice: null,
    };
  },
  watch: {
    // radios() {
    //   if (this.radios == "price") {
    //     this.product.price = null;
    //   }
    //   if (this.radios == "totalPrice") {
    //     this.newprice = null;
    //   }
    // },
    newprice() {
      var taxpercentage = this.singleSubcatData.HSN.gstPercentage;
      if (
        this.newprice > this.singleSubcatData.HSN.gstLevel2MinumumPrice &&
        this.singleSubcatData.HSN.gstLevel2MinumumPrice > 0
      ) {
        taxpercentage = this.singleSubcatData.HSN.gstLevel2Percentage;
      }
      var taxamount = (this.newprice * taxpercentage) / (100 + taxpercentage);
      this.product.productcost = this.newprice - taxamount;
    },
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    appType() {
      return this.$store.state.userType;
    },

    maincategoryArray() {
      // var arr = [];
      // arr =
      return this.$store.state.categories.data;
      // arr = arr.splice(0, 2);
      // return arr;
    },

    // subcategoryArray() {
    //   return this.$store.state.subCategoriesAll;
    // },
  },
  beforeMount() {
    // this.$store.dispatch("getStylCategory");
    this.$store.dispatch("Category");
    this.getDeliveryModes();
    this.getSellerProducts();
    // this.getSubcategory();
    // this.getCategory();
    // this.$store.dispatch("getSubCategory");
    // this.$store.dispatch("getSubCategoryAll");
    // this.getPincodes();
    // this.getTag();
    // this.getMaterial();
    // this.getProductTags();
    // this.getBrand();
  },
  methods: {
    getSellerProducts() {
      axios({
        method: "GET",
        url: "/view/seller/products",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          status: "All",
          count: 1000,
          page: 1,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellerProducts = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    preventSymbols(e) {
      if (["-", "+", "e", "E", "/"].includes(e.key)) {
        e.preventDefault();
        this.msg = "Please enter correct values. Symbols are not allowed.";
        this.showSnackBar = true;
      }
    },
    checkDiscountvariant() {
      if (this.product.offer) {
        this.product.offerPrice =
          this.product.price - (this.product.price * this.product.offer) / 100;
      } else if (this.product.price && this.product.offer == undefined) {
        this.product.offerPrice =
          this.product.price - (this.product.price * 0) / 100;
      } else if (this.product.price) {
        this.product.offerPrice =
          this.product.price - (this.product.price * this.product.offer) / 100;
      }
    },
    getSubcategory() {
      axios({
        method: "post",
        url: "/subcategory/getlist",
        data: {
          categoryId: this.product.category,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.subcategoryArray = response.data.data;
          } else {
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCategory() {
      axios({
        method: "post",
        url: "/category/getlist",
        data: {
          mainCategoryId: this.product.mainCategory,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.categoryArray = response.data.data;
          } else {
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    priceChanger(window_data) {
      if (window_data.price) {
        this.product.price = window_data.price;
        if (this.newprice !== window_data.price)
          this.newprice = window_data.price;
      }
    },
    winStepper(window_data) {
      this.productStock = window_data.productStock;
      this.product.size = this.productStock;
      this.product.stockquantity = 0;
      for (var i = 0; i < this.productStock.length; i++) {
        for (var j = 0; j < this.productStock[i].stock.length; j++) {
          this.product.stockquantity =
            this.product.stockquantity + this.productStock[i].stock[j].stock;
        }
      }
    },
    subSize(id) {
      for (var i = 0; i < this.subcategoryArray.length; i++) {
        if (id == this.subcategoryArray[i]._id) {
          this.subSizeArray = this.subcategoryArray[i].size;
          this.singleSubcatData = this.subcategoryArray[i];
        }
      }
    },
    checkNameAvailability() {
      // this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/name/available",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          name: this.product.productname,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            // this.NameMsg = response.data.msg;
            // this.appLoading = false;
          } else {
            this.NameMsg = response.data.msg;
            // this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getDeliveryModes() {
      axios({
        method: "get",
        url: "/product/delivery-modes",
        params: {
          _id: localStorage.getItem("sellerId"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.modeOfDeliveryItems = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductTags() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/producttag/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.productTags = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getBrand() {
      this.appLoading = true;
      axios({
        url: "/brand/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.brandArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getPincodes() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/pincode/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.pincodeArray = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getTag() {
      this.appLoading = true;
      axios({
        url: "/product/tagsuggestions",

        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.tagArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getMaterial() {
      this.appLoading = true;
      axios({
        url: "/product/materialusedsuggestions",

        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.materialArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadImages(event) {
      if (this.imageArray.length < 4) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;
        return;
      }
    },
    collectImages(image) {
      this.selectedFiles = image;
      this.Images.append("image", this.selectedFiles);
      this.formData.append("photos", this.selectedFiles);
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      this.imageArray.splice(i, 1);
    },
    validateInput() {
      if (!this.product.productname) {
        this.msg = "Please provide name";
        this.showSnackBar = true;
        return;
      } else if (!this.product.description) {
        this.msg = "Please provide description";
        this.showSnackBar = true;
        return;
      } else if (!this.product.price) {
        this.msg = "Please provide price";
        this.showSnackBar = true;
        return;
      } else if (!this.product.quantity) {
        this.msg = "Please provide quantity";
        this.showSnackBar = true;
        return;
      } else if (!this.product.maxOrderQuantity) {
        this.msg = "Please provide maximum order quantity";
        this.showSnackBar = true;
        return;
      } else if (!this.product.minimumOrderQuantity) {
        this.msg = "Please provide minimum order quantity";
        this.showSnackBar = true;
        return;
      } else if (!this.product.packingCharge) {
        this.msg = "Please provide Packing Charge";
        this.showSnackBar = true;
        return;
      } else if (!this.product.deliveryChargeInsideKerala) {
        this.msg = "Please provide Delivery Charge Inside Kerala";
        this.showSnackBar = true;
        return;
      } else if (!this.product.deliveryChargeOutsideKerala) {
        this.msg = "Please provide Delivery Charge Outside Kerala";
        this.showSnackBar = true;
        return;
      } else if (!this.product.tax) {
        this.msg = "Please provide Tax";
        this.showSnackBar = true;
        return;
      } else if (!this.product.mainCategory) {
        this.msg = "Please select main category";
        this.showSnackBar = true;
        return;
      } else if (!this.product.category) {
        this.msg = "Please select category";
        this.showSnackBar = true;
        return;
      } else if (!this.product.subcategory) {
        this.msg = "Please select subcategory";
        this.showSnackBar = true;
        return;
      } else if (!this.product.modeOfDelivery) {
        this.msg = "Please select mode of delivery";
        this.showSnackBar = true;
        return;
      } else if (this.product.isVariantAvailable && !this.product.variantName) {
        this.msg = "Please provide current product variant name";
        this.showSnackBar = true;
        return;
      } else {
        this.addProduct();
      }
    },
    addProduct() {
      this.appLoading = true;
      this.product.price = parseFloat(this.product.price);
      this.product.offer = parseFloat(this.product.offer);
      this.product.quantity = parseFloat(this.product.quantity);
      this.product.offerPrice = parseFloat(this.product.offerPrice);
      this.product.minimumOrderQuantity = parseFloat(
        this.product.minimumOrderQuantity
      );
      this.product.maxOrderQuantity = parseFloat(this.product.maxOrderQuantity);
      this.product.deliveryChargeInsideKerala = parseFloat(this.product.deliveryChargeInsideKerala);
      this.product.deliveryChargeOutsideKerala = parseFloat(this.product.deliveryChargeOutsideKerala);
      axios({
        method: "POST",
        url: "/product/Add",
        data: this.product,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            if (this.imageArray.length > 0) {
              this.uploadAllImages(response.data.product._id);
              this.msg = response.data.msg;
              this.showSnackBar = true;
            } else {
              window.location.reload();
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadAllImages(item) {
      this.appLoading = true;
      this.formData.append("productid", item);
      this.formData.append("sellerid", localStorage.getItem("sellerId"));
      axios({
        method: "POST",
        url: "/Product/UploadImageMultiple",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.formData = new FormData();
          if (response.data.status == true) {
            window.location.reload();
          } else {
            this.msg = "Can't Upload Images";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
/* ── Page Shell ─────────────────────────────── */
.add-product-page {
  min-height: 100vh;
  background: #f6f8fb;
}

/* ── Page Header ────────────────────────────── */
.page-header {
  background: #ffffff;
  border-bottom: 1px solid #e8ecf0;
  padding: 20px 28px;
  position: sticky;
  top: 0;
  z-index: 10;
}
.page-title-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-title-icon {
  font-size: 28px !important;
  color: #4caf50;
}
.page-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  color: #1c1c1c;
  margin: 0;
  line-height: 1.2;
}
.page-subtitle {
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  color: #888;
  margin: 2px 0 0;
}

/* ── Form Body ──────────────────────────────── */
.form-body {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}
.form-left-col {
  padding-right: 0;
}
@media (min-width: 1264px) {
  .form-left-col { padding-right: 20px; }
}
.form-right-col { padding-top: 0; }

/* ── Section Cards ──────────────────────────── */
.form-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.form-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f3f7;
  background: #fafbfc;
}
.section-number {
  font-family: poppinssemibold, sans-serif;
  font-size: 22px;
  color: #d0d8e4;
  line-height: 1;
  min-width: 36px;
}
.section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 15px;
  color: #1c1c1c;
  margin: 0;
}
.section-desc {
  font-family: poppinsregular, sans-serif;
  font-size: 12px;
  color: #999;
  margin: 2px 0 0;
}
.section-body { padding: 20px 24px; }

/* ── Fields ─────────────────────────────────── */
.field-group { margin-bottom: 4px; }
.field-label {
  display: block;
  font-family: poppinssemibold, sans-serif;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.required { color: #e53935; }
.field-error {
  font-family: poppinsregular, sans-serif;
  font-size: 11px;
  color: #e53935;
  margin-top: 3px;
  display: block;
}

/* ── Inputs ─────────────────────────────────── */
.modern-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 40px;
  background: #fdfdfd;
}
.modern-input >>> fieldset { border-color: #dde3ea !important; }
.modern-input:hover >>> fieldset { border-color: #4caf50 !important; }
.offer-price-field >>> .v-input__slot { background: #f9fff9 !important; }
.editor-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dde3ea;
}

/* ── Image Panel ────────────────────────────── */
.sticky-panel { position: sticky; top: 85px; }
.image-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  padding: 20px;
}
.image-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.image-section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 14px;
  color: #1c1c1c;
  flex: 1;
}
.image-count-badge {
  background: #e8f5e9;
  color: #2e7d32;
  font-family: poppinssemibold, sans-serif;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
}

/* ── Main Image ─────────────────────────────── */
.main-image-container {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e8ecf0;
  background: #f6f8fb;
  position: relative;
  margin-bottom: 12px;
}
.main-image-wrapper { position: relative; }
.main-image { border-radius: 10px; }
.placeholder-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.placeholder-text {
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  color: #b0b8c8;
  margin: 0;
}
.remove-img-btn {
  background: #ff3434 !important;
  margin: 6px 6px 0 0;
}

/* ── Thumbnails ─────────────────────────────── */
.thumbnail-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.thumbnail-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8ecf0;
}
.thumbnail-img { border-radius: 8px; }
.remove-thumb-btn {
  background: #ff3434 !important;
  margin: 2px 2px 0 0;
}

/* ── Upload Area ────────────────────────────── */
.upload-area {
  border: 2px dashed #c8d4df;
  border-radius: 10px;
  padding: 18px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  margin-bottom: 16px;
  background: #fafcfe;
}
.upload-area:hover {
  border-color: #4caf50;
  background: #f1faf2;
}
.upload-icon { font-size: 28px !important; margin-bottom: 4px; }
.upload-label {
  font-family: poppinssemibold, sans-serif;
  font-size: 13px;
  color: #444;
}
.upload-hint {
  font-family: poppinsregular, sans-serif;
  font-size: 11px;
  color: #aaa;
}

/* ── Submit Button ──────────────────────────── */
.submit-btn {
  border-radius: 8px !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.5px;
  height: 48px !important;
  background: linear-gradient(135deg, #43a047, #66bb6a) !important;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.35) !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease !important;
}
.submit-btn:hover {
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.45) !important;
  transform: translateY(-1px);
}
.submit-area-mobile { margin-top: 8px; margin-bottom: 24px; }

/* ── Utilities ──────────────────────────────── */
.v-select > .dropdown-menu { text-align: right; }
.radC >>> label {
  font-family: opensansbold;
  color: #000000;
  font-size: 13px;
  padding-left: 10px;
}

/* ── Responsive ─────────────────────────────── */
@media (max-width: 960px) {
  .form-body { padding: 16px 12px 40px; }
  .section-header { padding: 14px 16px; }
  .section-body { padding: 14px 16px; }
  .page-header { padding: 14px 16px; }
}
@media (max-width: 600px) {
  .section-number { font-size: 16px; min-width: 28px; }
  .section-title { font-size: 14px; }
}
</style>
